export const QrCodeScanName = 'qrCodeScanComponent';
